import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { bindAll } from '@bibliocommons/utils-react';
import { catalogBibShape, libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import { getRelationships } from 'app/actions/RelationshipsActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectStaffListsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { trackContentClick, trackContentImpression } from 'app/actions/AnalyticsGa4Actions';
import { UI_COMPONENT_TYPE, UI_CONTAINER_TYPE, UI_CONTAINER_TITLE } from 'app/constants/AnalyticsGa4Constants';

import StaffLists from './StaffLists';

export class StaffListsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  componentDidMount() {
    const { currentUser, getRelationshipsAction, lists } = this.props;
    if (currentUser?.isEmpty() ?? true) {
      return;
    }

    const listOwnerIds = lists?.map(list => list.getIn(['owner', 'id']));

    getRelationshipsAction({ userId: currentUser.get('id'), userIds: listOwnerIds });
  }

  handleListTitleClick({ impressionId, listId, listTitle }) {
    const properties = {
      impression_id: impressionId
    };
    const ui = {
      ui_container_type: UI_CONTAINER_TYPE.SECTION,
      ui_container_title: UI_CONTAINER_TITLE.STAFF_LISTS_FEATURING_THIS_TITLE,
      ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
      ui_component_label: listTitle
    };
    this.props.trackContentClick({ listId, properties, ui });
  }

  handleListImageClick({ impressionId, listId }) {
    const properties = {
      impression_id: impressionId
    };
    const ui = {
      ui_container_type: UI_CONTAINER_TYPE.SECTION,
      ui_container_title: UI_CONTAINER_TITLE.STAFF_LISTS_FEATURING_THIS_TITLE,
      ui_component_type: UI_COMPONENT_TYPE.LINK_IMAGE
    };
    this.props.trackContentClick({ listId, properties, ui });
  }

  handleListImpression({ impressionId, listId }) {
    const properties = {
      impression_id: impressionId
    };
    const ui = {
      ui_container_type: UI_CONTAINER_TYPE.SECTION,
      ui_container_title: UI_CONTAINER_TITLE.STAFF_LISTS_FEATURING_THIS_TITLE
    };
    this.props.trackContentImpression({ properties, listId, ui });
  }

  render() {
    return (
      <StaffLists
        {...this.props}
        handleListTitleClick={this.handleListTitleClick}
        handleListImageClick={this.handleListImageClick}
        handleListImpression={this.handleListImpression}
      />
    );
  }
}

StaffListsContainer.propTypes = {
  catalogBib: catalogBibShape,
  currentUser: userIdentityShape,
  getRelationshipsAction: PropTypes.func.isRequired,
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  library: libraryShape,
  trackContentClick: PropTypes.func,
  trackContentImpression: PropTypes.func,
  users: ImmutablePropTypes.mapOf(userIdentityShape)
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  currentUser: selectCurrentUser(state),
  users: selectUserEntities(state),
  lists: selectStaffListsForCurrentBib(state),
  library: selectCurrentLibrary(state)
});

const mapDispatchToProps = {
  getRelationshipsAction: getRelationships,
  trackContentClick,
  trackContentImpression
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffListsContainer);
